import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../api';

const ROLE_LABELS = { admin: 'Admin', designer: 'Designer', requester: 'Requester' };

export default function ProfileSection({ loggedInUser }) {
  const [profile, setProfile] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/api/users/${encodeURIComponent(loggedInUser)}/profile`, { params: { username: loggedInUser } })
      .then((res) => setProfile(res.data))
      .catch(() => setFailed(true));
  }, [loggedInUser]);

  if (failed) return <p className="text-sm text-red-600">Could not load the profile.</p>;
  if (!profile) return <p className="text-sm text-gray-500">Loading…</p>;

  const changed = profile.password_updated_at
    ? new Date(profile.password_updated_at).toLocaleDateString('en-GB')
    : 'never changed';
  return (
    <dl className="grid grid-cols-[10rem_1fr] gap-y-2 text-sm max-w-md">
      <dt className="text-gray-500 dark:text-gray-400">Username</dt>
      <dd className="font-semibold">{profile.username}</dd>
      <dt className="text-gray-500 dark:text-gray-400">Role</dt>
      <dd>{ROLE_LABELS[profile.role] || profile.role}</dd>
      <dt className="text-gray-500 dark:text-gray-400">Password last changed</dt>
      <dd>{changed}</dd>
    </dl>
  );
}
